import {GEAR} from './character';
import {skillById,type Shortcut} from './professions';
import {itemName} from './huntEconomy';
import {classSkillIcon} from './classSkillAssets';
import {itemIcon} from './uiIcons';
const escape=(s:string)=>s.replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]!));
export function shortcutName(binding:Shortcut):string{
 if(!binding)return 'ช่องว่าง · ใส่สกิลหรือไอเทม';
 return binding.kind==='skill'?skillById(binding.id)?.name??binding.id:GEAR.find(g=>g.id===binding.id)?.name??itemName(binding.id);
}
export function shortcutContent(binding:Shortcut):string{
 if(!binding)return '<span class="slot-plus" aria-hidden="true">+</span>';
 const icon=shortcutIcon(binding);
 return `${icon?`<img class="shortcut-icon" src="${icon}" alt="">`:'<span class="shortcut-icon shortcut-icon-missing" aria-hidden="true">?</span>'}<span>${escape(shortcutName(binding))}</span>`;
}
export function shortcutIcon(binding:Shortcut):string|undefined{
 if(!binding)return undefined;
 if(binding.kind==='skill')return classSkillIcon(binding.id);
 return itemIcon(binding.id);
}
